import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './MandatoryNotification.html?raw';
import "../Icon/Icon";
// NOTE (JS2TS): dropped dead deps dojo/dom-construct, dojo/dom-style, dojo/_base/lang (imported but unused in code/template).
// more/Legacy/Controls/Icon/Icon kept as a bare side-effect import (non-dojo dep declared in the original define, must not be dropped).

class MandatoryNotification extends compose(_WidgetBaseSP) {
    [key: string]: any;
    templateString: any = template;

    _infoText = "this input is mandatory";

    _setInfoTextAttr(value: any) {

        this._infoText = value;

        this.infoTextNode.innerHTML = this._infoText;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this._infoText = this.translate('MandatoryNotification__MainText');
        this.set("infoText", this._infoText);
    }
}
MandatoryNotification.prototype.declaredClass = 'more.Controls.MandatoryNotification';

export default mdsWidget(MandatoryNotification);
